export default __webpack_public_path__ + "static/media/dog-camping.99dbf9c1.webp";